import { render, staticRenderFns } from "./MainProfilePreview.vue?vue&type=template&id=35141e34&scoped=true&"
import script from "./MainProfilePreview.vue?vue&type=script&lang=js&"
export * from "./MainProfilePreview.vue?vue&type=script&lang=js&"
import style0 from "./MainProfilePreview.vue?vue&type=style&index=0&id=35141e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35141e34",
  null
  
)

export default component.exports